import { useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let setSelectedCampaigns = useDataChange({
    context: 'tab',
    path: 'selected.configurations',
    viewPath: props.viewPath,
  })

  return async function onClick(value) {
    let selected_configuration_ids = Array.isArray(value) ? value : [value]

    setSelectedCampaigns(selected_configuration_ids)
  }
}
